import {
  DotLine,
  typographyStyle,
  Colors,
  KeyboardArrowRight,
  KeyboardArrowDownLine,
  Flex,
} from '@revenuemarket/cds';
import { Typography } from 'antd';
import { useRouter } from 'next/router';

import { css } from '~libs/emotion';

import NavigationMenu, { NavigationItem } from './NavigationMenu';
import useNavigationStore from './useNavigationStore';

interface Props {
  title: string;
  titleNode?: React.ReactNode;

  items: NavigationItem[];
}

const NavigationMenuGroup: React.FC<Props> = ({ title, titleNode, items }) => {
  const { activeKey, openedGroupKeys, setOpenedGroupKeys } = useNavigationStore();
  const router = useRouter();
  const opened = openedGroupKeys.includes(title);
  const selectedGroupItem = items.find(
    (item) =>
      item.activeKey === activeKey ||
      (item.link &&
        (router.asPath === item.link ||
          router.asPath.startsWith(`${item.link}?`) ||
          router.asPath.startsWith(`${item.link}/`))),
  );

  return (
    <Flex direction="column">
      <Flex
        align="center"
        gap={4}
        style={{
          cursor: 'pointer',
          padding: '6px 8px',
        }}
        onClick={() => {
          if (openedGroupKeys.includes(title)) {
            setOpenedGroupKeys(openedGroupKeys.filter((key) => key !== title));
          } else {
            setOpenedGroupKeys([...openedGroupKeys, title]);
          }
        }}
        className={css`
          border-radius: 8px;
          &:hover {
            background: ${Colors.grayOpacity04};
          }
        `}
      >
        {openedGroupKeys.includes(title) ? (
          <KeyboardArrowDownLine />
        ) : (
          <KeyboardArrowRight width={18} height={18} />
        )}
        {titleNode || (
          <Typography.Text
            style={{
              ...typographyStyle['14_400'],
              color: Colors.gray700,
            }}
          >
            {title}
          </Typography.Text>
        )}
      </Flex>
      {opened ? (
        items.map((item) => (
          <NavigationMenu
            style={{
              padding: '6px 4px',
              paddingLeft: 16,
              cursor: 'pointer',
            }}
            icon={<DotLine />}
            key={item.activeKey}
            activeKey={item.activeKey}
            title={item.title}
            onClick={item.onClick}
            link={item.link}
            dataType={item.dataType}
            customAttributes={item.customAttributes}
          />
        ))
      ) : selectedGroupItem ? (
        <NavigationMenu
          style={{
            padding: '6px 4px',
            marginLeft: 8,
            cursor: 'pointer',
          }}
          icon={<DotLine />}
          key={selectedGroupItem.activeKey}
          activeKey={selectedGroupItem.activeKey}
          title={selectedGroupItem.title}
          onClick={selectedGroupItem.onClick}
          link={selectedGroupItem.link}
          dataType={selectedGroupItem.dataType}
          customAttributes={selectedGroupItem.customAttributes}
        />
      ) : null}
    </Flex>
  );
};

export default NavigationMenuGroup;
